<template>
  <div
    @click="navigateTo()"
    class="img"
    :style="{
      backgroundImage:
        'url(' + require('../assets/' + image_name + '.png') + ')',
    }"
  >
    <div id="comToReadBorder" v-if="comToRead > 0">
      <div id="comToRead">{{ comToRead }}</div>
    </div>
  </div>
</template>
<style>
#comToRead {
  height: 30px;
  width: 30px;
  background-color: red;
  border-radius: 30px;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  text-align: center;
  line-height: 30px;
  color: white;
  font: normal normal bold 25px Roboto;
}

#comToReadBorder {
  height: 30px;
  width: 30px;

  border-radius: 30px;
  position: absolute;
  right: 6px;
  top: 5px;
}
</style>

<script>
import { Trans } from "@/plugins/Translation";
import router from "@/router/index.js";
import MyFercamApi from "../api/MyFercam/MyFercamApi.js";

export default {
  props: {
    isHeader: false,
  },

  computed: {
    communicationsUpdated: function () {
      return this.$store.getters.GET_communicationsUpdated;
    },
  },

  watch: {
    communicationsUpdated: {
      handler() {
        // console.log("communications updated mail");
        this.getCommunications(this.$GAUserAuth.user);
      },
    },
  },

  data() {
    return {
      comToRead: 0,
      image_name: "communications_email",
    };
  },

  async created() {
    // window.addEventListener("resize", this.myEventHandler);
    // this.setIsMobile();

    await this.$GAUserAuth.refreshUserInfo().then((res) => {
      this.getCommunications(this.$GAUserAuth.user);
    });
  },

  methods: {
    navigateTo(source) {
      this.closeMenu();
      router.push({ name: "communications" }).catch((err) => {
        this.$store.commit(
          "SET_refreshCommunications",
          !this.$store.getters.GET_refreshCommunications
        );
      });
    },
    getCommunications(user) {
      MyFercamApi.GetCommunications(
        user.companyCode,
        user.username,
        false
      ).then((res) => {
        this.comToRead = res.data.length;

        this.image_name = !this.isHeader
          ? "comunicazioni_mobile"
          : "communications_email";

        if (this.comToRead > 0) this.image_name += "_toread";
      });
    },
    closeMenu() {
      let showSM = {
        show: false,
        style: "color: #cecece",
      };

      this.$store.commit("SET_showSearchMenu", showSM);
    },
  },
};
</script>

<style>
</style>